import { render, staticRenderFns } from "./PlanejamentoAcaoVerbaVariavelFormRodape.vue?vue&type=template&id=c60b06ca"
import script from "./PlanejamentoAcaoVerbaVariavelFormRodape.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoVerbaVariavelFormRodape.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoVerbaVariavelFormRodape.vue?vue&type=style&index=0&id=c60b06ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports